import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from "@apollo/client";
import { OTP_API_URI } from "./config";

const otpHttpLink = new HttpLink({ uri: OTP_API_URI });

const routeLink = new ApolloLink((operation, forward) => {
  const context = operation.getContext();
  const endpoint = context?.endpoint;

  // this will return the otp endpoint uri
  if (endpoint === "OTP_ENDPOINT") return otpHttpLink.request(operation, forward);

  // throw an error if no endpoint is provided
  throw Error("Please provide an endpoint");
});

const client = new ApolloClient({
  link: routeLink,
  cache: new InMemoryCache(),
});

export default client;
